import React from 'react'
import { useTranslation } from 'react-i18next'
import { PromotionalFooterPure, TitleTemplatePure, Container, Stepper, SimpleLoading, HeaderHLPure, DialogSystemGLPure } from '../../pures'
import './request-reliable-signature.css'

const RequestReliableSignatureView = (props) => {
  const { t } = useTranslation()
  const { selectedStep, stepMetadata, steps, loading, messageComplete, messageError, messageWarning, showLoadingRequesting, toggleLoadingRequesting, showCompletedRequesting, toggleCompletedRequesting, showErrorRequesting, toggleErrorRequesting, toggleWarningRequesting, showWarningRequesting } = props
  const step = steps[selectedStep]
  const { component: StepComponent, back, next } = stepMetadata[selectedStep]
  const title = `${step.title}.`
  const subtitle = `
    ${t('configurationPlanRenovationView.steps')} ${selectedStep + 1} 
    ${t('configurationPlanRenovationView.of')} ${steps.length}
  `

  return (
    <Container>
      <HeaderHLPure title={t('requestReliableSignature.reliableSignatureTitle')} />
      <Stepper
        steps={steps}
        selectedStep={selectedStep}
        title={title}
        subtitle={subtitle}
      />
      <div className='center-container'>
        {loading ? (
          <div className='card-description-reliable'>
            <SimpleLoading />
          </div>
        ) : (
          <>
            <StepComponent
              step={step}
              onHandleNext={next}
              onHandleBack={back}
              {...props}
            />
            <DialogSystemGLPure
              messageError={messageError}

              showLoadingRequesting={showLoadingRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}

              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
              messageComplete={messageComplete}

              showErrorRequesting={showErrorRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
              
              showWarningRequesting={showWarningRequesting}
              toggleWarningRequesting={toggleWarningRequesting}
              messageWarning={messageWarning}
            />
          </>
          
        )}
      </div>
      <PromotionalFooterPure />
    </Container>
  )
}

export default RequestReliableSignatureView
